module.exports = __webpack_public_path__ + "img/k09.9c64605e.png";